module.exports = __webpack_public_path__ + "static/img/bac3.21c7a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/bac3.png
// module id = 6Bw/
// module chunks = 2